package com.solevo.dist.network.firebase

import com.solevo.dist.application.models.Customer
import com.solevo.dist.application.models.User
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.customers.CustomerRemoteSource
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import com.solevo.dist.network.implementation.firebase.api.customers.models.FirebaseCustomer
import com.solevo.dist.network.implementation.firebase.api.customers.models.toCustomer
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.mapNotNull


/**
 * Created by Ilija Vucetic on 29.8.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */

class CustomerFirebaseRemoteSource : CustomerRemoteSource {

    private val firestore = Firebase.firestore

    override fun currentCustomer(): Flow<Customer?> {
        return when {
            currentCustomerId.value.isNotEmpty() ->
                firestore.collection(FirestoreCollections.CUSTOMERS_COLLECTION)
                    .where {
                        all(
                            FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value),
                            FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId)
                        )
                    }
                    .snapshots()
                    .filter { it.documents.isNotEmpty() }
                    .mapNotNull { querySnapshot ->
                        val firebaseCustomer = querySnapshot.documents.map {
                            it.data(
                                FirebaseCustomer.serializer()
                            )
                        }.firstOrNull() ?: return@mapNotNull null
                        val customer = firebaseCustomer.toCustomer()
                        User.userCurrency = customer.currency
                        User.defaultWarehouseId = customer.defaultWarehouseId
                        User.customer = customer
                        Customer.customerGroupId = customer.groupId
                        customer
                    }

            else -> flow { emit(null) }
        }
    }

    override suspend fun customer(): Result<Customer?> {
        return runCatching {
            firestore.collection(FirestoreCollections.CUSTOMERS_COLLECTION)
                .where {
                    all(
                        FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value),
                        FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId)
                    )
                }
                .get()
                .documents.firstOrNull()?.let { doc ->
                    return@runCatching doc.data(FirebaseCustomer.serializer()).toCustomer()
                }
            null
        }
    }
}
